const modifiedSearchField = (searchInput) => {
  const trimmedInput = searchInput?.trim();

  if (!trimmedInput) return "";

  const splitedInput = trimmedInput.split(/\s+/).join(" ");

  if (!/\s+/g.test(splitedInput) || /\b(OR|AND)\b/i.test(splitedInput))
    return splitedInput;
  return splitedInput.replace(/\s+/g, " AND ");
};

export const buildFilterQuery = (filter) => {
  const {
    author_id,
    assignee_id,
    task_status,
    task_id,
    subtasks,
    task_type_id,
    search,
  } = filter;

  return {
    elastic_search: modifiedSearchField(search),
    ...(author_id && { author_id }),
    ...(assignee_id && { assignee_id }),
    // Always send task_status (default "all"): on the BE the
    // `showAssignedOnly` permission scoping lives INSIDE the task_status
    // filter lambda (task_resource.rb), so omitting the param would skip
    // that scoping entirely. "all" applies the scoping without narrowing
    // by status. Matters since A2 made an empty filter the default
    // (URL-driven filters, empty URL = empty filter).
    task_status: task_status || "all",
    ...(task_id && { task_id }),
    ...(subtasks && { addressable_task_id: subtasks }),
    ...(task_type_id && { task_type_id }),
  };
};
